import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'

import { useSelector } from 'react-redux'

function TruckDetails(props: any) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setAppTitle('Truck List'))
  }, [])

  const data = props?.selectedTruck
  console.log(data)

  return (
    <>
      <div className=''>
        <div className='card'>
          <div className='card-header'>
            <h4 className='card-title'>Vehicle Details</h4>
            <a href='javascript:void(0);' className='clear-truck-list'>
              <i className='fas fa-xmark'></i>
            </a>
          </div>
          <div className='card-body'>
            <div className='truck-sidebar-btns'>
              <a href='javascript:void(0);' className='btn btn-light'>
                <i className='feather-edit'></i> Edit
              </a>
              <a href='javascript:void(0);' className='btn btn-secondary'>
                <i className='feather-trash-2'></i> Delete
              </a>
            </div>
            <div className='truck-information'>
              <h4>Truck Information</h4>
              <div className='truck-information-grid'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Truck Make / Modal</p>
                      <h6>{data.model_name}</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Truck Licence Number</p>
                      <h6>{data.license_number}</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Truck Number</p>
                      <h6>{data.truck_number}</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Year</p>
                      <h6>{data.year}</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Inspector</p>
                      <h6>Dominic</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Inspection Date</p>
                      <h6>04-06-2024 10AM</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='truck-information'>
              <h4>Driver/Company Details</h4>
              <div className='truck-information-grid'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Driver Name</p>
                      <h6>Cameron Jacob</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Company Name</p>
                      <h6>ABC Company</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Phone Number</p>
                      <h6>+1 456-7890</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Email Address</p>
                      <h6>abc@company.com</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>TIN Number</p>
                      <h6>1759013776</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Address</p>
                      <h6>132, My Street, Kingston, New York</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='truck-information'>
              <h4>Inspection Details</h4>
              <div className='truck-information-grid'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Checklist</p>
                      <h6>Completed</h6>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='truck-information-content'>
                      <p>Checklist</p>
                      <div className='truck-list-text'>
                        <ul className='nav datas-list'>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                          <li>
                            <span className='check-list-active'></span>
                          </li>
                        </ul>
                        <h5>
                          28/<span>30</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <a href='javascript:void(0);' className='btn btn-light'>
              Cancel
            </a>
            <a href='javascript:void(0);' className='btn btn-primary'>
              Go to Checklist
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
export default TruckDetails
